import { ETLDispatcher } from 'lib/ETLDispatcher';
import { MetricData } from 'lib/MetricTracking';

export class MetricsDispatcher extends ETLDispatcher<MetricData> {
  getEndpoint(): string {
    return '/v1/statsdproxy';
  }

  requestPayload(items: MetricData[]): { [key: string]: any } {
    return {
      metrics_batch: items,
      client_properties: this.sessionProperties,
    };
  }

  log(item: MetricData) {
    console.groupCollapsed(`%c⚡️ METRIC - ${item.name}`, 'color: #962857');
    console.log({ item, batch_properties: this.sessionProperties });
    console.groupEnd();
  }
}
